import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { getReflexivePronoun } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/userUtils'

import { tID } from '../../utils/utils'
import { BodyText, Size as BodyTextSize } from '../bodyText/BodyText'
import { InfoIcon } from '../icons/InfoIcon'
import { Title, Size as TitleSize } from '../title/Title'
import { Tooltip } from '../tooltip/Tooltip'

export type SelfPayStatusProps = {
  clientName: string
  pronouns?: string[]
  isActive: boolean
}

const TitleContainer = styled.View({
  display: 'flex',
  flexDirection: 'row',
})

const TooltipContainer = styled.View({
  marginLeft: 4,
})

export const SelfPayStatus: FunctionComponent<SelfPayStatusProps> = ({ clientName, pronouns, isActive }) => {
  const { formatMessage } = useIntl()
  const { colors } = useTheme()
  let valueColor

  if (isActive) {
    valueColor = colors.textSuccess
  }

  const tooltipContent = formatMessage(
    {
      defaultMessage: 'After covered sessions, {clientName} can pay for care {reflexivePronoun}.',
      description: 'Tooltip content for self pay status',
    },
    { clientName, reflexivePronoun: getReflexivePronoun(pronouns) },
  )

  return (
    <>
      <TitleContainer>
        <BodyText
          text={formatMessage({ defaultMessage: 'Self-pay', description: 'Title for self pay status section' })}
          size={BodyTextSize.CAPTION}
          color={colors.textSecondary}
        />
        <TooltipContainer>
          <Tooltip
            hoverEnabled
            content={tooltipContent}
            placement='top'
            accessibilityLabel={formatMessage({
              defaultMessage: 'More information about self-pay status',
              description: 'Accessibility label for self-pay status tooltip',
            })}
          >
            <InfoIcon size={18} fillColor={colors.iconActive} />
          </Tooltip>
        </TooltipContainer>
      </TitleContainer>

      <Title
        text={
          isActive
            ? formatMessage({ defaultMessage: 'Active', description: 'Self pay status active' })
            : formatMessage({ defaultMessage: 'Eligible', description: 'Self pay status eligible' })
        }
        size={TitleSize.SMALL}
        color={valueColor}
        testID={tID('SelfPayStatus-status')}
      />
    </>
  )
}
